import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { UserCheck, ArrowRight } from "lucide-react";

export function ProfileCompletenessCard() {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/creators/me/completeness").then((r) => setC(r.data)).catch(() => {}); }, []);
  if (!c || c.complete) return null;
  return (
    <div className="rounded-2xl border border-nexus-pink/25 bg-nexus-pink/5 p-5 flex flex-col md:flex-row md:items-center gap-4" data-testid="profile-completeness-card">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 text-sm font-semibold text-white"><UserCheck className="h-4 w-4 text-nexus-pink" /> Your profile is {c.percent}% complete</div>
        <div className="mt-2 h-1.5 rounded-full bg-white/10 overflow-hidden"><div className="h-full nexus-gradient" style={{ width: `${c.percent}%` }} data-testid="profile-completeness-bar" /></div>
        <p className="text-xs text-zinc-400 mt-2">Complete profiles get ~4× more offers and rank higher in Discover. Still missing: <span className="text-zinc-200">{c.missing.slice(0, 4).join(", ")}{c.missing.length > 4 ? ` +${c.missing.length - 4} more` : ""}</span>.</p>
      </div>
      <Link to="/creator/profile" className="inline-flex items-center gap-1.5 text-xs font-semibold nexus-gradient text-white px-4 h-9 rounded-full hover:opacity-90 shrink-0 self-start md:self-center" data-testid="profile-completeness-cta">Finish profile <ArrowRight className="h-3.5 w-3.5" /></Link>
    </div>
  );
}
